import { Route, Routes } from 'react-router-dom';
import App from '../App';
import { NotFoundPage } from '../pages/NotFoundPage';

/**
 * The route table from `index.js:82-85` — unchanged: `/` renders the app, anything else
 * renders the 404 page.
 *
 * The backend's SPA fallback serves index.html for any non-`/api` path, so a deep link
 * still reaches React and lands here, exactly as nginx's `try_files $uri $uri/
 * /index.html` did before.
 */
export function AppRoutes(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
